import { ILaunchViewModel } from '@monofe/ui-workspace/launch/interface';
import { IAssetFetcher } from '../../interface/asset';
import { IConfigManifest } from '../../interface/config';
import defaultProps from './defaultProps';
import {
    ILaunchEvent,
    ILaunchState,
    IStateProcessor,
    IStateProcessorLaunchState,
} from './state/events';

function mapping(
    downloadClick: () => void,
    skipClick: () => void,
    manifest: IConfigManifest,
    assets: IAssetFetcher,
    processor: IStateProcessor<ILaunchState, ILaunchEvent, IStateProcessorLaunchState>,
): ILaunchViewModel {
    let model: ILaunchViewModel = defaultProps();

    model.downloadButton.onClick = downloadClick;
    model.skipButton.onClick = skipClick;

    model.status = {
        text: '',
        fontFamily: 'Gill Sans',
        fontSize: '8vmin',
        fontAlignment: 'center',
        fontWeight: 300,
        color: '#000',
        visible: true,
    };

    model.detail = {
        text: '',
        fontFamily: 'Gill Sans',
        fontSize: '3vmin',
        fontAlignment: 'center',
        fontWeight: 300,
        color: '#000',
        visible: false,
    };

    switch (processor.status()) {
        default:
        case ILaunchState.Initializing:
            model.progressBar.visible = false;
            model.status.text = '...Loading';
            break;

        case ILaunchState.UpdatingSite:
            model.progressBar.visible = true;
            model.progressBar.progress = processor.state().updateSiteProgress ?? 0;
            model.status.text = '...Updating';
            break;

        case ILaunchState.AwaitingUserDownloadSkipConfirmation:
            model.progressBar.visible = false;
            model.progressBar.progress = processor.state().updateSiteProgress ?? 0;
            model.status.text = 'Download all content now?';
            break;

        case ILaunchState.DownloadingMedia:
            model.progressBar.visible = true;
            model.progressBar.progress = processor.state().downloadMediaProgress ?? 0;
            model.status.text = '...Downloading';
            break;

        case ILaunchState.Halted:
            model.progressBar.visible = false;
            model.status.text = '...Please refresh page';
            model.detail.text = processor.error() ?? '';
            model.detail.visible = true;
            break;
    }

    const showingUserDialog =
        processor.status() === ILaunchState.AwaitingUserDownloadSkipConfirmation;

    model.downloadButton.visible = showingUserDialog;
    model.skipButton.visible = showingUserDialog;

    model.backgroundColor = manifest.background_color;
    model.status.color = manifest.theme_color;

    const image = assets.imageAssetGroupClosestMatch(
        'Splash',
        window.innerWidth * window.devicePixelRatio,
        window.innerHeight * window.devicePixelRatio,
    );

    model.backgroundImage.url = image.path;

    model.status.visible = processor.state().activeEvent > ILaunchEvent.Start;

    return model;
}

export default mapping;
